import { render, staticRenderFns } from "./KitForm.vue?vue&type=template&id=3a239890"
import script from "./KitForm.vue?vue&type=script&lang=js"
export * from "./KitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports